import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import './Addvartisement.css'


const Addvartisement = () => {
  return (
    <Container fluid>
      <Row>
        <Col className="text-center">
          
          <p className="add">Stay Home, Stay Safe. Order Now </p>
           
              
            

          
        </Col>
      </Row>
    </Container>
  );
};

export default Addvartisement;
